<template>
  <v-toolbar-items>
    <v-menu offset-y bottom open-on-hover>
      <template v-slot:activator="{ on }">
        <v-btn v-on="on" text>
        <v-badge
          overlap
          color="green"
          v-model="showBadge"
          @click.native="showBadge = !showBadge"
        >
          <span slot="badge">{{ badgeData }}</span>
          <v-icon
            color="grey darken-1"
            medium
          >
            notifications</v-icon>
        </v-badge>
      </v-btn>
      </template>
      <v-list v-if="badgeData">
        <v-list-item
          v-for="(item, i) in notifications"
          :key="i"
        >
          <v-list-item-title>{{ item }}</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
  </v-toolbar-items>
</template>

<script>
  export default {
    name: 'header-component-notifications',
    data () {
      return {
        showBadge: true
      }
    },
    computed: {
      notifications () {
        return this.$store.getters.getNotifications
      },
      badgeData () {
        return this.notifications.length
      }
    }
  }
</script>
